import { render, staticRenderFns } from "./show.vue?vue&type=template&id=1fd4d3c3"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports